import BlogsForm from "./BlogForm";
const BlogEdit = () => {
    return ( <BlogsForm /> )
}

export default BlogEdit;